/* Shared modal element (size finder, gallery lightbox, on-the-gram).
   <dotto-modal> extends the overlay base with centered-modal display.
   Triggers use the same [data-drawer-toggle="<id>"] contract as drawers.
   Guarded: if dotto.js has not executed (it loads first from
   theme.liquid), fail loudly instead of killing every modal quietly. */

const Base = window.Dotto && window.Dotto.OverlayElement;

if (!Base) {
  console.warn('DOTTO: dotto.js must load before modal.js — modals disabled.');
} else if (!customElements.get('dotto-modal')) {
  customElements.define(
    'dotto-modal',
    class DottoModal extends Base {
      open(opener) {
        this.classList.add('is-open');
        super.open(opener);
      }

      close() {
        this.classList.remove('is-open');
        super.close();
      }
    }
  );
}
